import { useEffect, useRef } from "react";
import ResultsFoodNoise from "components/Results/ResultsFoodNoise";
import { pageView, setPageData } from "utils/analytics";
import useUrlSlugContext from "components/UrlSlugContext";
import { loadResultsCookieByBaseUrl } from "components/Results/storeResultsData";
import { ResultsFoodNoiseCookie } from "types/cookie";

interface ResultsRestoredFoodNoiseProps {
  page?: number;
}

const ResultsRestoredFoodNoise = ({ page = 1 }: ResultsRestoredFoodNoiseProps): JSX.Element => {
  const { baseUrl } = useUrlSlugContext();
  const cookie = loadResultsCookieByBaseUrl(baseUrl) || {} as ResultsFoodNoiseCookie;
  const resultsScreen = useRef(cookie?.resultsScreen).current;
  const profile = useRef(cookie?.profile).current;

  useEffect(() => {
    if (page === 1) {
      pageView("result-revisited", "fnqz");
    } else {
      pageView("result-revisited-2", "fnqz");
    }

    setPageData({
      questionnaire_result: resultsScreen?.sum,
    });
  }, [page]);

  return (
    <ResultsFoodNoise
      results={resultsScreen}
      profile={profile}
      resultsRestored={true}
      page={page}
    />
  );
};

export default ResultsRestoredFoodNoise;
